import { IEquipmentModel } from '@/pages/Equipment/pages/EquipmentModels/equipmentModels.types.ts'
import { HTMLProps } from 'react'
import useEquipmentModel from '@/pages/Equipment/pages/EquipmentModels/hooks/useEquipmentModel.ts'

interface IProps {
  modelId: IEquipmentModel['id']
}

const EquipmentModelNameSpan = ({ modelId, ...props }: IProps & HTMLProps<HTMLSpanElement>) => {
  const model = useEquipmentModel(modelId)

  return <span {...props}>{model ? model.name : '-'}</span>
}

export default EquipmentModelNameSpan
